import GeneratedOutOfOfficeStore from "./generated/GeneratedOutOfOfficeStore"

class OutOfOfficeStore extends GeneratedOutOfOfficeStore {

}

export const outOfOfficeStore = new OutOfOfficeStore()
